// Success toasts name what actually happened. API calls no longer show a
// generic "done" message; each action calls notifySuccess() itself.
import toastr from "toastr";

const OPTIONS = {
    closeButton: true,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-bottom-right",
    preventDuplicates: true,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "4000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

export function notifySuccess(message) {
    toastr.options = { ...OPTIONS };
    toastr.success(message);
}
